import {
  SET_EXERCISEDESCRIPTION,
  SET_EXERCISENAME, SET_EXERCISEZONEID,
} from "./pseudoModalsTypes";
import { createAction } from "@reduxjs/toolkit";

export const setExerciseName = createAction<string>(SET_EXERCISENAME);

export const setExerciseZoneId = createAction<number>(SET_EXERCISEZONEID);
export const setExerciseDescription = createAction<string>(SET_EXERCISEDESCRIPTION);